module.exports = __webpack_public_path__ + "static/media/hedera-logo.76bc34b5.png";